var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 733,
    height: 720,
    viewBox: "0 0 733 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M366.5 155.825C477.512 155.825 567.63 247.168 567.63 360C567.63 472.832 477.512 564.175 366.5 564.175C255.488 564.175 165.37 472.832 165.37 360C165.37 247.168 255.488 155.825 366.5 155.825Z",
    stroke: "#FC6B68",
    strokeOpacity: 0.7,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M588.108 360C588.108 484.331 488.808 584.97 366.5 584.97C244.192 584.97 144.892 484.331 144.892 360C144.892 235.669 244.192 135.03 366.5 135.03C488.808 135.03 588.108 235.669 588.108 360Z",
    stroke: "#FC6B68",
    strokeOpacity: 0.7,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M681.913 360C681.913 537.343 540.34 680.455 366.5 680.455C192.66 680.455 51.0873 537.343 51.0873 360C51.0873 182.657 192.66 39.5446 366.5 39.5446C540.34 39.5446 681.913 182.657 681.913 360Z",
    stroke: "#FC6B68",
    strokeOpacity: 0.7,
    strokeWidth: 52
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M545.351 360C545.351 460.335 465.215 541.559 366.5 541.559C267.785 541.559 187.649 460.335 187.649 360C187.649 259.665 267.785 178.441 366.5 178.441C465.215 178.441 545.351 259.665 545.351 360Z",
    stroke: "#FC6B68",
    strokeOpacity: 0.7,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M501.607 360C501.607 436.313 440.98 497.926 366.5 497.926C292.02 497.926 231.393 436.313 231.393 360C231.393 283.687 292.02 222.074 366.5 222.074C440.98 222.074 501.607 283.687 501.607 360Z",
    stroke: "#FC6B68",
    strokeOpacity: 0.7,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M610.481 360C610.481 496.825 501.192 607.644 366.5 607.644C231.808 607.644 122.519 496.825 122.519 360C122.519 223.175 231.808 112.356 366.5 112.356C501.192 112.356 610.481 223.175 610.481 360Z",
    stroke: "#FC6B68",
    strokeOpacity: 0.7,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M629.746 360C629.746 507.6 511.845 627.178 366.5 627.178C221.155 627.178 103.254 507.6 103.254 360C103.254 212.4 221.155 92.8218 366.5 92.8218C511.845 92.8218 629.746 212.4 629.746 360Z",
    stroke: "#FC6B68",
    strokeOpacity: 0.7,
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M644.093 360C644.093 515.619 519.783 641.723 366.5 641.723C213.217 641.723 88.9069 515.619 88.9069 360C88.9069 204.381 213.217 78.2772 366.5 78.2772C519.783 78.2772 644.093 204.381 644.093 360Z",
    stroke: "#FC6B68",
    strokeOpacity: 0.7,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M660.25 360C660.25 524.674 528.706 658.119 366.5 658.119C204.294 658.119 72.7495 524.674 72.7495 360C72.7495 195.326 204.294 61.8812 366.5 61.8812C528.706 61.8812 660.25 195.326 660.25 360Z",
    stroke: "#FC6B68",
    strokeOpacity: 0.7,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M525.194 360C525.194 449.126 454.027 521.163 366.5 521.163C278.973 521.163 207.806 449.126 207.806 360C207.806 270.874 278.973 198.837 366.5 198.837C454.027 198.837 525.194 270.874 525.194 360Z",
    stroke: "#FC6B68",
    strokeOpacity: 0.7,
    strokeWidth: 17
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M730.5 360C730.5 557.687 567.563 718 366.5 718C165.437 718 2.5 557.687 2.5 360C2.5 162.313 165.437 2 366.5 2C567.563 2 730.5 162.313 730.5 360Z",
    stroke: "#FC6B68",
    strokeOpacity: 0.7,
    strokeWidth: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.1c916cd0e1d7106721e8bfb698fe15ad.svg";
export { ForwardRef as ReactComponent };